export default __webpack_public_path__ + "static/media/Vector.ce3a126d.svg";